import { toast } from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import { request } from '@core/api/request';
import { queryClient } from '@core/api/query-client';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

export const deleteBankAccount = async ({
  id,
  userId,
}: {
  id: number;
  userId: number;
}) => {
  return await request({
    url: `members/${userId}/bank-accounts/${id}`,
    method: 'DELETE',
  });
};

export const useDeleteBankAccount = () => {
  return useMutation({
    mutationFn: deleteBankAccount,
    onError: (error: string) => {
      toast.error(error);
    },
    onSuccess: () => {
      toast.success('Bank Info has deleted successfully.');
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.getUserById],
      });
    },
  });
};
